/**
 * Stops Swiper autoplay while the instance root is outside the viewport and
 * restarts it when it becomes visible again. Reduces timer/work for off-screen carousels.
 *
 * @param {*} swiper Swiper instance
 * @param {{ root?: Element | null; rootMargin?: string; threshold?: number | number[] }} [options]
 * @returns {() => void} Call before destroying the Swiper instance.
 */
export function bindSwiperAutoplayToViewport(swiper, options = {}) {
  if (!swiper?.el || typeof IntersectionObserver === "undefined") {
    return () => {};
  }

  const autoplayParam = swiper.params?.autoplay;
  const hasAutoplay = Boolean(
    autoplayParam && autoplayParam !== false,
  );
  if (!hasAutoplay || !swiper.autoplay) {
    return () => {};
  }

  const rootMargin = options.rootMargin ?? "0px";
  const threshold = options.threshold ?? 0;
  const root = options.root ?? null;

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (!entry || !swiper.autoplay) {
        return;
      }

      if (entry.isIntersecting) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    },
    { root, rootMargin, threshold },
  );

  observer.observe(swiper.el);

  return () => {
    observer.disconnect();
  };
}
